<template lang="pug">
  v-app
    a-navigation
    a-toolbar
    v-content
      router-view
</template>

<script>
import { mapGetters } from 'vuex'
import '@/services/auth'
import ANavigation from '@/components/AppNavigation'
import AToolbar from '@/components/AppToolbar'

export default {
  components: {
    ANavigation,
    AToolbar
  },
  mounted () {
    this.$store.dispatch('toolbar/hide')
    this.$store.dispatch('navigation/hide')
    this.updateStage()
  },
  watch: {
    isLogined (val) {
      this.updateStage()
    }
  },
  computed: {
    ...mapGetters({
      isLogined: 'user/isLogined'
    })
  },
  methods: {
    updateStage () {
      const path = (this.isLogined) ? '/home' : '/login'
      const action = (this.isLogined) ? 'show' : 'hide'
      this.$router.push(path)
      this.$store.dispatch(`toolbar/${action}`)
      this.$store.dispatch(`navigation/${action}`)
    }
  }

}
</script>

<style lang="stylus"></style>
